import React from 'react';

import { useEmailActivityQuery } from 'src/api';
import { PageLayout } from 'src/components/common';
import { useFilter, usePagination } from 'src/hooks/common';

import { EmailTrackerTable } from './components';
import { prepareFilters } from './utils/tableFilters';

export const EmailTrackerTableOnClearVerifyStaff: React.FC = () => {
  const { filter } = useFilter();

  const { rowsPerPage } = usePagination();

  const { data, loading, refetch } = useEmailActivityQuery({
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    variables: {
      limit: rowsPerPage,
      ...prepareFilters(filter),
    },
  });

  const refetchData = React.useCallback(async () => {
    await refetch();
  }, [refetch]);

  const emailActivityList = React.useMemo(() => {
    return data?.getEmailActivity.messages ?? [];
  }, [data?.getEmailActivity.messages]);

  return (
    <PageLayout titleContent="Email Tracker">
      <EmailTrackerTable
        emailActivityList={emailActivityList}
        loading={loading}
        refetchData={refetchData}
      />
    </PageLayout>
  );
};
